import React from 'react'

import { Form, Button } from '_zari/core'

import { PartidaCrudModal } from 'sharedComponents/modals'

import * as PartidaService from 'services/partida.service'

const Select2ProveedorInput = ({ showNewButton, idSocio, ...props }) => {
  const [mostrarPartidaCrudModal, setMostrarPartidaCrudModal] = React.useState(false)
  const [partidas, setPartidas] = React.useState([])

  React.useEffect(() => {
    PartidaService.getxSocioAsSelect(idSocio)
      .then(({ data }) => setPartidas(data))
      .catch(() => setPartidas([]))
  }, [idSocio])

  const clickMostrarPartidaCrudModalHandler = React.useCallback(() => {
    setMostrarPartidaCrudModal(true)
  }, [])

  const handleClose = React.useCallback(() => {
    setMostrarPartidaCrudModal(false)
    PartidaService.getxSocioAsSelect(idSocio)
      .then(({ data }) => setPartidas(data))
      .catch(() => setPartidas([]))
  }, [idSocio])

  return (
    <>
      {showNewButton ? (
        <Form.InputGroup>
          <Form.Select {...props} disabled={!idSocio || props.disabled}>
            <option value=''>Seleccionar</option>
            {partidas.map(x => (
              <option key={x._id} value={x._id}>
                {x.titulo}
              </option>
            ))}
          </Form.Select>
          <Form.InputGroup.Append>
            <Button
              disabled={!idSocio || props.disabled}
              onClick={clickMostrarPartidaCrudModalHandler}
            >
              &#x2b;
            </Button>
          </Form.InputGroup.Append>
        </Form.InputGroup>
      ) : (
        <Form.Select {...props} disabled={!idSocio || props.disabled}>
          <option value=''>Seleccionar</option>
          {partidas.map(x => (
            <option key={x._id} value={x._id}>
              {x.titulo}
            </option>
          ))}
        </Form.Select>
      )}
      {mostrarPartidaCrudModal && (
        <PartidaCrudModal
          handleClose={handleClose}
          show={mostrarPartidaCrudModal}
          idSocio={idSocio}
        />
      )}
    </>
  )
}

export default React.memo(Select2ProveedorInput)
